// components/common/Card/Card.tsx
import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

type CardPadding = 'none' | 'small' | 'medium' | 'large';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hover?: boolean;
  padding?: CardPadding;
  /** When true (default) shows the card surface (background, border, shadow). */
  background?: boolean;
}

const PADDING_CLASS: Record<CardPadding, string> = {
  none: styles.paddingNone,
  small: styles.paddingSmall,
  medium: styles.paddingMedium,
  large: styles.paddingLarge,
};

const Card = ({
  children,
  className = '',
  hover = true,
  padding = 'medium',
  background = true,
  ...props
}: CardProps) => {
  const classes = [
    styles.card,
    background ? styles.surface : '',
    hover ? styles.hover : '',
    PADDING_CLASS[padding],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
